module.exports = __webpack_public_path__ + "img/product_52.6cdaf15.webp";